@if (isFullOverlay()) {
  <div class="background-effect-image"></div>
}

<div
  class="background-image"
  [@simpleFadeAnimation]="{ params: { enterDuration: transitionTimeout(), leaveDuration: 500 } }"
  [ngClass]="{ 'half-z-index': !isFullOverlay(), 'full-z-index': isFullOverlay(), 'fade-in': isFullOverlay() }"
>
  <div class="items-container">
    <div class="mask-logo">
      <img src="../../../assets/images/logos/bubble-navy-3-color.svg" alt="Scoot Logo" />
    </div>
    <div class="overlay-text">
      {{ overlayText() }}
    </div>

    <div class="loading-bar-container">
      <mat-progress-bar
        class="loading-bar"
        [ngClass]="{ 'bar-hidden': !isFullOverlay() }"
        mode="indeterminate"
      ></mat-progress-bar>
    </div>
  </div>
</div>
